'use strict';

var Collection = require('js/lib/collection');
var Profile = require('js/models/profile');
var Model = require('js/lib/model');
var _ = require('underscore');
var config = require('js/config');

var unFilteredState = {
  roleId: null,
  searchText: '',
  isLoading: false,
  hasError: false,
  page: 1,
};

/**
 * Members
 * @exports Members
 * @constructor
 * @alias module:collections/members
 */
var Members = Collection.extend({
  model: Profile,
  url: config.build.apiPath + '/api/members',
  total: 0,
});

/**
 * Create a model as attribute to filter the content of the collection
 */
Members.prototype.startFiltering = function(filters) {
  if (this.state) {
    this.state.set(filters);
    return;
  }
  this.state = new Model;
  this.state.set(unFilteredState);
  this.filtersApplying = unFilteredState;
  this.filteringCallback =_.debounce(this.synchroneFetch.bind(this), 200).bind(this);
  this.state.on('change', this.filteringCallback);
  this.state.set(filters);
};

/**
 *  Clean the model created for filtering
 */
Members.prototype.stopFiltering = function() {
  this.filtersApplying = null;
  if (!this.state) {
    return;
  }
  this.state.off('change', this.filteringCallback);
  this.state = null;
};

/**
 * Parse response payload from api
 */
Members.prototype.parse = function(resp) {
  // Extract total num of members
  this.total = resp.total || 0;
  const members = resp.members.map(member => {
    return {
      ...member,
      userRoles: resp.users.find(user => user.userId === member.userId).userRoles || member.roles,
    };
  });

  const userList = members || resp.userInfo || [];
  if (this.state) {
    this.state.set({hasMore: userList.length === (this.description.pageSize || config.pageSize.members)});
  }
  return userList;
};

/**
 * set the paramaters of the request on the model
 */
Members.prototype.setRequest = function(request) {
  if (request.roleId !== null) {
    this.desc('roleid', request.roleId);
  } else {
    this.clearDesc('roleid');
  }

  if (request.searchText === '') {
    this.clearDesc('searchText');
    this.clearDesc('filter');
  } else {
    this.desc('searchText', request.searchText);
    this.desc('filter', 'searchKey');
  }

  this.desc('PageNumber', request.page);
  this.desc('PageSize', config.pageSize.members);
};

Members.prototype.updateRequest = function(request) {
  this.state.set({hasError: false, ...request});
};

/**
 * fetch the appropriate users according the last users
 */
Members.prototype.synchroneFetch = function() {
  if (!this.state || this.state.get('isLoading') || this.state.get('hasError')) {
    return;
  }
  var isResetting =
    this.filtersApplying.roleId !== (this.state.get('roleId') || null) ||
    this.filtersApplying.searchText !== (this.state.get('searchText') || '');

  var desiredFilters = Object.assign({}, unFilteredState, this.state.attributes);

  if (isResetting) {
    desiredFilters.page = 1;
  } else if (this.filtersApplying.page >= this.state.get('page') || this.total === this.length) {
    return;
  } else {
    desiredFilters.page = this.filtersApplying.page + 1;
  }

  this.setRequest(desiredFilters);
  this.fetch({
    remove: isResetting,
    reset: isResetting,
    success: () => {
      this.filtersApplying = desiredFilters;
      this.state.set({isLoading: false, hasError: false});
    },
    error: () => {
      this.state.set({isLoading: false, hasError: true});
    },
  });
  this.state.set({isLoading: true, hasError: false});
};

module.exports = Members;



// WEBPACK FOOTER //
// ./app/assets/js/collections/members.js